var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("h3", [
        _vm._v("Punto de emision " + _vm._s(_vm.modelValue.numero_secuencia))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "numero_secuencia", placeholder: "###" },
                model: {
                  value: _vm.modelValue.numero_secuencia,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_secuencia", $$v)
                  },
                  expression: "modelValue.numero_secuencia"
                }
              },
              [
                _vm._v("\n          N° de secuencia\n          "),
                _vm.errores.numero_secuencia
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_secuencia[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-field select2",
            class: { "select2--disabled": _vm.modelValue.id !== "" }
          },
          [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    label: "descripcion",
                    options: _vm.tiposComprobante,
                    placeholder: "Seleccione...",
                    id: "tipoComprobante"
                  },
                  model: {
                    value: _vm.selectedTipoComprobante,
                    callback: function($$v) {
                      _vm.selectedTipoComprobante = $$v
                    },
                    expression: "selectedTipoComprobante"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipoComprobante" } }, [
                  _vm._v("Tipo de comprobante")
                ]),
                _vm._v(" "),
                _vm.errores.id_tipo_comprobante
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.id_tipo_comprobante[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-inline" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    this.modelValue.id_tipo_comprobante !== "00" &&
                    this.modelValue.id_tipo_comprobante !== "99",
                  expression:
                    "this.modelValue.id_tipo_comprobante !== '00' && this.modelValue.id_tipo_comprobante !== '99'"
                }
              ],
              attrs: { for: "electronico" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.tipo,
                    expression: "modelValue.tipo"
                  }
                ],
                attrs: {
                  type: "radio",
                  disabled: _vm.modelValue.id !== "",
                  id: "electronico",
                  value: "E"
                },
                domProps: { checked: _vm._q(_vm.modelValue.tipo, "E") },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.modelValue, "tipo", "E")
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Electrónico")])
            ]
          ),
          _vm._v(" "),
          _c("label", { attrs: { for: "manual" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.modelValue.tipo,
                  expression: "modelValue.tipo"
                }
              ],
              attrs: {
                disabled: _vm.modelValue.id !== "",
                type: "radio",
                id: "manual",
                value: "M"
              },
              domProps: { checked: _vm._q(_vm.modelValue.tipo, "M") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.modelValue, "tipo", "M")
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Manual")])
          ]),
          _vm._v(" "),
          _vm.errores.tipo
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [_c("strong", [_vm._v(_vm._s(_vm.errores.tipo[0]))])]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.modelValue.id_tipo_comprobante !== "00" &&
                  _vm.modelValue.tipo === "M",
                expression:
                  "modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "##########",
                    expression: "'##########'"
                  }
                ],
                attrs: {
                  type: "tel",
                  id: "numero_autorizacion",
                  placeholder: "##########"
                },
                model: {
                  value: _vm.modelValue.numero_autorizacion,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_autorizacion", $$v)
                  },
                  expression: "modelValue.numero_autorizacion"
                }
              },
              [
                _vm._v("\n          Número de autorización\n          "),
                _vm.errores.numero_autorizacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_autorizacion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.modelValue.id_tipo_comprobante !== "00" &&
                  _vm.modelValue.tipo === "M",
                expression:
                  "modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "#########",
                    expression: "'#########'"
                  }
                ],
                attrs: {
                  type: "tel",
                  id: "numero_inicial",
                  placeholder: "#########"
                },
                model: {
                  value: _vm.modelValue.numero_inicial,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_inicial", $$v)
                  },
                  expression: "modelValue.numero_inicial"
                }
              },
              [
                _vm._v("\n          Número inicial\n          "),
                _vm.errores.numero_inicial
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_inicial[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modelValue.pre_impresion,
                expression: "modelValue.pre_impresion"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                attrs: { id: "medida_superior", placeholder: "cm" },
                model: {
                  value: _vm.modelValue.medida_superior,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "medida_superior", $$v)
                  },
                  expression: "modelValue.medida_superior"
                }
              },
              [
                _vm._v("\n          Medida superior\n          "),
                _vm.errores.medida_superior
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.medida_superior[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.modelValue.id_tipo_comprobante !== "00" &&
                  _vm.modelValue.tipo === "M",
                expression:
                  "modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "div",
              { staticClass: "datepicker-field" },
              [
                _c("date-picker", {
                  attrs: {
                    type: "date",
                    format: "dd-MM-yyyy",
                    id: "fecha_caducidad",
                    lang: "es"
                  },
                  model: {
                    value: _vm.modelValue.fecha_caducidad,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "fecha_caducidad", $$v)
                    },
                    expression: "modelValue.fecha_caducidad"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "fecha_caducidad" } }, [
                  _vm._v("Fecha de caducidad")
                ]),
                _vm._v(" "),
                _vm.errores.fecha_caducidad
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.fecha_caducidad[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "descripcionPuntoEmision",
                  placeholder: "Nombre o descripción"
                },
                model: {
                  value: _vm.modelValue.descripcion,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "descripcion", $$v)
                  },
                  expression: "modelValue.descripcion"
                }
              },
              [
                _vm._v("\n          Descripción\n          "),
                _vm.errores.descripcion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.descripcion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "#########",
                    expression: "'#########'"
                  }
                ],
                attrs: {
                  readonly:
                    _vm.modelValue.id !== "" && _vm.modelValue.tipo === "E",
                  type: "tel",
                  id: "numero_actual",
                  placeholder: "#########"
                },
                model: {
                  value: _vm.modelValue.numero_actual,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_actual", $$v)
                  },
                  expression: "modelValue.numero_actual"
                }
              },
              [
                _vm._v("\n          Número actual\n          "),
                _vm.errores.numero_actual
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_actual[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.modelValue.id_tipo_comprobante !== "00" &&
                  _vm.modelValue.tipo === "M",
                expression:
                  "modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "#########",
                    expression: "'#########'"
                  }
                ],
                attrs: {
                  type: "tel",
                  id: "numero_final",
                  placeholder: "#########"
                },
                model: {
                  value: _vm.modelValue.numero_final,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_final", $$v)
                  },
                  expression: "modelValue.numero_final"
                }
              },
              [
                _vm._v("\n          Número final\n          "),
                _vm.errores.numero_final
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_final[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.modelValue.id_tipo_comprobante !== "00" &&
                  _vm.modelValue.tipo === "M",
                expression:
                  "modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "div",
              { staticClass: "datepicker-field" },
              [
                _c("date-picker", {
                  attrs: {
                    type: "date",
                    format: "dd-MM-yyyy",
                    id: "fecha_autorizacion",
                    lang: "es"
                  },
                  model: {
                    value: _vm.modelValue.fecha_autorizacion,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "fecha_autorizacion", $$v)
                    },
                    expression: "modelValue.fecha_autorizacion"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "fecha_autorizacion" } }, [
                  _vm._v("Fecha de autorización")
                ]),
                _vm._v(" "),
                _vm.errores.fecha_autorizacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.fecha_autorizacion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "nombre",
                  options: _vm.usuarios,
                  multiple: "",
                  id: "usuarios",
                  placeholder: "Seleccione..."
                },
                model: {
                  value: _vm.selectedUsuarios,
                  callback: function($$v) {
                    _vm.selectedUsuarios = $$v
                  },
                  expression: "selectedUsuarios"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "usuarios" } }, [_vm._v("Usuarios")]),
              _vm._v(" "),
              _vm.errores.usuarios
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.usuarios[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-field" }, [
          _c("label", { attrs: { for: "puntoVenta" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.modelValue.punto_venta,
                  expression: "modelValue.punto_venta"
                }
              ],
              attrs: { type: "checkbox", id: "puntoVenta" },
              domProps: {
                checked: Array.isArray(_vm.modelValue.punto_venta)
                  ? _vm._i(_vm.modelValue.punto_venta, null) > -1
                  : _vm.modelValue.punto_venta
              },
              on: {
                change: function($event) {
                  var $$a = _vm.modelValue.punto_venta,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.modelValue,
                          "punto_venta",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.modelValue,
                          "punto_venta",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.modelValue, "punto_venta", $$c)
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Impresión por punto de venta")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "es_autorizable" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.modelValue.es_autorizable,
                  expression: "modelValue.es_autorizable"
                }
              ],
              attrs: { type: "checkbox", id: "es_autorizable" },
              domProps: {
                checked: Array.isArray(_vm.modelValue.es_autorizable)
                  ? _vm._i(_vm.modelValue.es_autorizable, null) > -1
                  : _vm.modelValue.es_autorizable
              },
              on: {
                change: function($event) {
                  var $$a = _vm.modelValue.es_autorizable,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.modelValue,
                          "es_autorizable",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.modelValue,
                          "es_autorizable",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.modelValue, "es_autorizable", $$c)
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Es autorizable")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "grava_iva" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.modelValue.grava_iva,
                  expression: "modelValue.grava_iva"
                }
              ],
              attrs: { type: "checkbox", id: "grava_iva" },
              domProps: {
                checked: Array.isArray(_vm.modelValue.grava_iva)
                  ? _vm._i(_vm.modelValue.grava_iva, null) > -1
                  : _vm.modelValue.grava_iva
              },
              on: {
                change: function($event) {
                  var $$a = _vm.modelValue.grava_iva,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.modelValue, "grava_iva", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.modelValue,
                          "grava_iva",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.modelValue, "grava_iva", $$c)
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Grava IVA")])
          ]),
          _vm._v(" "),
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.modelValue.tipo === "M" && _vm.modelValue.punto_venta,
                  expression:
                    "modelValue.tipo === 'M' && modelValue.punto_venta"
                }
              ]
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.pre_impresion,
                    expression: "modelValue.pre_impresion"
                  }
                ],
                attrs: { type: "checkbox", id: "pre_impresion" },
                domProps: {
                  checked: Array.isArray(_vm.modelValue.pre_impresion)
                    ? _vm._i(_vm.modelValue.pre_impresion, null) > -1
                    : _vm.modelValue.pre_impresion
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.modelValue.pre_impresion,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.modelValue,
                            "pre_impresion",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.modelValue,
                            "pre_impresion",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.modelValue, "pre_impresion", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Formato pre-impreso")])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modelValue.pre_impresion,
                expression: "modelValue.pre_impresion"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                attrs: { id: "medida_inferior", placeholder: "cm" },
                model: {
                  value: _vm.modelValue.medida_inferior,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "medida_inferior", $$v)
                  },
                  expression: "modelValue.medida_inferior"
                }
              },
              [
                _c("span", [_vm._v("Medida superior")]),
                _vm._v(" "),
                _vm.errores.medida_inferior
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.medida_inferior[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.cerrar }
        },
        [
          _c("i", { staticClass: "fa fa-close" }),
          _vm._v(" "),
          _c("span", [_vm._v("Cerrar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _vm._v(" "),
          _c("span", [_vm._v("Aceptar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("p", [_c("strong", [_vm._v("Tipo de punto de emisión")])])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-691ca1ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-691ca1ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/localidades/PuntoEmision.vue
// module id = 511
// module chunks = 0